<template>
    <div class="conversation-cell" @mouseenter="showMenu = true" @mouseleave="showMenu = false">
        <div v-if="conversation" class="conversation-info" @click="viewConversation">
            <div class="conversation-icon">
                <a-icon type="message" />
            </div>
            <div class="conversation-details">
                <span class="conversation-name">Sohbeti Görüntüle</span>
            </div>
        </div>
        <PermissionController :permissions="['table.update']" v-else>
            <a @click="showConversationPicker">+ Sohbet Ekle</a>
        </PermissionController>
        <!-- Hover Overlay'de Aksiyon İkonları -->
        <div class="overlay-actions" v-if="showMenu && conversation && !readonly">
            <PermissionController :permissions="['table.update']">
                <a-button
                    icon="delete"
                    type="danger"
                    size="small"
                    @click="removeConversation"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    content="Sohbeti Kaldır"
                ></a-button>
            </PermissionController>
        </div>

        <!-- Sohbet ID'si Giriş Modalı -->
        <Modal2
            v-if="showModal"
            @cancel="closeModal"
            :title="'Sohbet ID Girin'"
            :okText="'Kaydet'"
            :cancelText="'İptal'"
            @ok="saveConversationId"
        >
            <div class="conversation-id-form">
                <a-form-item label="Sohbet ID">
                    <a-input v-model="inputConversationId" placeholder="Sohbet ID'sini girin" />
                </a-form-item>
                <div class="form-info">
                    <a-alert type="info" show-icon>
                        <span slot="message">
                            Sohbet ID'sini sohbet ekranından veya sohbet listesinden alabilirsiniz.
                        </span>
                    </a-alert>
                </div>
            </div>
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ConversationCell",
    components: {
        SupsisButton,
        Modal2,
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showMenu: false,
            showModal: false,
            inputConversationId: "",
        };
    },
    computed: {
        conversation() {
            return this.record.data[this.field._id];
        },
    },
    methods: {
        viewConversation() {
            if (!this.conversation) return;
            // Conversation detayını TableRecords bileşenine emit ediyoruz
            this.$emit('view-conversation', this.conversation);
        },
        showConversationPicker() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.inputConversationId = "";
        },
        async saveConversationId() {
            if (!this.inputConversationId.trim()) {
                this.$message.error("Lütfen geçerli bir Sohbet ID'si girin");
                return;
            }

            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: this.inputConversationId.trim(),
                });
                this.$message.success("Sohbet bağlantısı başarıyla eklendi");
                this.closeModal();
            } catch (error) {
                console.error("Sohbet bağlantısı eklenirken hata oluştu:", error);
                this.$message.error("Sohbet bağlantısı eklenirken bir hata oluştu");
            }
        },
        async removeConversation() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }

            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: null,
                });
                this.$message.success("Sohbet bağlantısı başarıyla kaldırıldı");
            } catch (error) {
                console.error("Sohbet bağlantısı kaldırılırken hata oluştu:", error);
                this.$message.error("Sohbet bağlantısı kaldırılırken bir hata oluştu");
            }
        },
    },
});
</script>

<style scoped lang="scss">
.conversation-cell {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    .conversation-info {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: background-color 0.2s ease;
        max-width: calc(100% - 20px);

        &:hover {
            background: var(--color-bg-neutral-hover);
        }

        .conversation-icon {
            min-width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: var(--color-bg-neutral-hover);
            color: #1890ff;
        }

        .conversation-details {
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }

    .conversation-name {
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .no-conversation {
        color: #999;
        font-style: italic;
    }

    .overlay-actions {
        position: absolute;
        top: 2px;
        right: 2px;
        display: flex;
        gap: 4px;
    }
}

.conversation-id-form {
    padding: 10px;

    .form-info {
        margin-top: 16px;
    }
}
</style>
